import React from 'react';
import './IconButton.css';

/*
 * IconButton — the mock's `.iconbtn`: a square, bordered, icon-only button.
 *   size    : 'md' (34px) | 'sm' (30px)
 *   variant : 'default' | 'ghost'
 *   label   : REQUIRED — accessible name (also used as the tooltip title)
 * Pass the icon as children, e.g. <IconButton label="Close"><Icon name="close"/></IconButton>.
 */
export default function IconButton({
  size = 'md',
  variant = 'default',
  label,
  title,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  const cls = [
    'iconbtn',
    size === 'sm' ? 'iconbtn--sm' : '',
    variant === 'ghost' ? 'iconbtn--ghost' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={cls}
      aria-label={label}
      title={title != null ? title : label}
      {...rest}
    >
      {children}
    </button>
  );
}
